/**
 * Direct Checkout JS
 */

const $ = window.jQuery;

let addedProdId;
let productIds = [];

$('.simpler--table .button').each(function (ind, btn) {
  productIds.push($(btn).attr('data-add_to_cart'));
});

$('.simpler--table .button').on('click', function () {
  addedProdId = $(this).attr('data-add_to_cart');
  // show form
  $('.one_page_checkout').show();
  // scroll to form
  scrollToElement('#direct_checkout_form');
  // reset all buttons
  $('.add_to_cart_button').not($(this)).text('Buy Now');

  let btnText = $(this).text();
  if (btnText === 'Remove') {
    $(this).text('Buy Now');
  } else {
    $(this).text('Remove');
  }
});

$(document).on('click', 'tr.cart_item a.remove', function () {
  let productId = $(this).attr('data-gtm4wp_product_id');
  $('#product_' + productId).text('Buy Now');
});

$(document.body).on('updated_checkout', function (e, r, t) {
  let prodIds = [];

  // scroll to notification if cart is empty
  if (!$('.cart_item').length && $('#opc-messages').html().length > 0) {
    $('.one_page_checkout').hide();
    scrollToElement('#opc-messages');
    $('.cart-table').remove();
    $('.recurring_details').remove();
  }

  // remove duplicate when sub prod is in cart and refresh
  if ($('.cart-table')[1]) {
    $('.cart-table')[1].remove();
    $('.recurring_details')[1].remove();
  }

  $('.cart_item').each(function (ind, item) {
    let productId = $(item).attr('data-add_to_cart');
    prodIds.push(productId);
    // remove from cart without the added one
    if (
      addedProdId &&
      addedProdId !== productId &&
      productIds.includes(productId)
    ) {
      $(item).find('a.remove').trigger('click');
    }
  });

  get_legal_text(prodIds);
});

$('.cart_item').each(function (ind, item) {
  let productId = $(item).attr('data-add_to_cart');

  // hide form if product in cart don't match pricing table products
  if (!productIds.includes(productId)) {
    $('.one_page_checkout').hide();
  } else {
    $('.one_page_checkout').show();
  }

  // Show form if product in cart is selected from the page
  if (
    $('.selected .add_to_cart_button').attr('data-add_to_cart') === productId
  ) {
    $('.one_page_checkout').show();
  }
});

// Single product page
$('.direct_checkout_button').on('click', function () {
  $('.one_page_checkout').show();
  scrollToElement('#direct_checkout_form');
  $('.add_to_cart_button.checkout-quantity').trigger('click');
});

// set pricing table header height
var headerHeight = $('.simpler--table-header').outerHeight();
$('.table_desc_tip').outerHeight(headerHeight);

buttonText();
// check if product is added and change button text
function buttonText() {
  let selectedBtn = $(
    '.selected button.add_to_cart_button, .selected a.add_to_cart_button'
  );
  if ($('.simpler--table-col').hasClass('selected')) {
    selectedBtn.text('Remove');
  } else {
    selectedBtn.text('Buy Now');
  }
}

// scroll to element
function scrollToElement(el) {
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $(el).offset().top - 50,
    },
    1000
  );
}

function get_legal_text(ids) {
  let prodIds = ids.join(',');
  const baseUrl = window.location.origin;
  const url = baseUrl + '/wp-json/dcupdate/v1/get-wording';
  $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json', // added data type
    data: {
      productId: prodIds,
    },
    success: function (res) {
      if (!res) {
        $('.cart-table').remove();
        $('.recurring_details').remove();
      }
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      console.error(textStatus);
    },
  });
}

if ($('.wc_avatax_validate_address').length > 0) {
  $('form#direct_checkout_form').on('submit', function validateAddress(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    //Avatax validation is just for US address
    if ($('#billing_country').val() === 'US') {
      $('.woocommerce-billing-fields .wc_avatax_validate_address').click();

      const observer = new MutationObserver(function (mutations_list) {
        mutations_list.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (added_node) {
            if (
              added_node.classList.contains(
                'wc-avatax-address-validation-success'
              )
            ) {
              $('form#direct_checkout_form').off('submit', validateAddress);
              $('#place_order').click();
            }
          });
        });
      });
      observer.observe(document.querySelector('.woocommerce-billing-fields'), {
        subtree: false,
        childList: true,
      });
    } else {
      $('form#direct_checkout_form').off('submit', validateAddress);
      $('#place_order').click();
    }
  });
}
